import { apiCall, API } from '../../utils/APIFunctions';

export function searchObjects(params, globalAbortController) {
  let url = `${API}/elasticsearch/objects/search?q=${params.q}&size=${params.size}&from=${params.from}`
  if (params.searchFolders !== undefined) {
    url += `&searchFolders=${params.searchFolders}`;
  }
  return apiCall(url, "GET", null, globalAbortController.signal);
}